import { autoinject } from 'aurelia-framework';

import { GenericApi, ParamType } from '~/api/generic-api';
import { NotesModel } from '~/models/notes-model';
import { FetchUtils, HttpMethod } from '~/utils/fetch-utils';

@autoinject
export class NotesApi extends GenericApi {
	private getNotesURL(
		functionName: string,
		recordId: number,
		queryParams?: Map<string, string>,
	) {
		const paramsString = GenericApi.getParamsString(
			{},
			[ParamType.FORM, ParamType.DIVISION],
			queryParams,
		);
		return (
			GenericApi.apiServerURL +
			'api/' +
			functionName +
			'/' +
			recordId +
			'/notes?' +
			paramsString
		);
	}

	public checkNotesData(
		functionName: string,
		recordId: number,
		queryParams?: Map<string, string>,
	): Promise<number> {
		const url = this.getNotesURL(functionName, recordId, queryParams);
		return FetchUtils.fetchResponseStatus(
			HttpMethod.HEAD,
			url,
			{},
			undefined,
			{
				extractParamsFromURL: true,
			},
		);
	}

	public getNotesData(
		functionName: string,
		recordId: number,
		queryParams?: Map<string, string>,
	): Promise<NotesModel> {
		const url = this.getNotesURL(functionName, recordId, queryParams);
		return FetchUtils.getJSONWithParamsInURL<NotesModel>(url);
	}

	public static hasNotes(notesData: NotesModel | number): boolean {
		const RESPONSE_STATUS_OK: number = 200;
		if (typeof notesData === 'number') {
			return notesData === RESPONSE_STATUS_OK;
		} else {
			return !(notesData.noteText == null || notesData.noteText === '');
		}
	}

	public saveNotesData(
		functionName: string,
		recordId: number,
		notesModel: NotesModel,
		queryParams?: Map<string, string>,
	): Promise<any> {
		const url = this.getNotesURL(functionName, recordId, queryParams);
		return FetchUtils.fetchJSON(
			HttpMethod.PUT,
			url,
			{},
			{
				noteText: notesModel.noteText,
				inError: notesModel.inError,
			},
			{
				extractParamsFromURL: true,
			},
		);
	}

	public deleteNotesData(
		functionName: string,
		recordId: number,
		queryParams?: Map<string, string>,
	): Promise<any> {
		const url = this.getNotesURL(functionName, recordId, queryParams);
		return FetchUtils.fetchJSON(HttpMethod.DELETE, url, {}, undefined, {
			extractParamsFromURL: true,
		});
	}
}
